import React from "react";

import styles from "./new-chat-select.module.scss";
import { NewChatSelectProps } from "./new-chat-select.types";

const NewChatSelect: React.FC<NewChatSelectProps> = (props: NewChatSelectProps) => {
  return (
    <div className={styles.newChatSelectComponent}>
      <div
        className={styles.newChatSelectItem}
        onClick={(): void => {
          props.setNewChatButtonState();
          props.setNewChatModalIsOpen(true);
        }}
      >
        New Chat User
      </div>
      <div
        className={styles.newChatSelectItem}
        onClick={(): void => {
          props.setNewChatButtonState();
          props.setNewChatServiceModalIsOpen(true);
        }}
      >
        New Chat Twilio
      </div>
    </div>
  );
};

export default NewChatSelect;
